"use client"

import React, { useState } from "react";

const Accordion = ({ title, questions, variant = "default" }) => {
    const isDark = variant === "dark";
    const titleColor = isDark ? "text-white" : "text-[#2C6E63]";

    return (
        <div className="container mx-auto">
            {title && (
                <div className="-mx-4 flex flex-wrap">
                    <div className="w-full px-4">
                        <div className="mx-auto mb-1 md:mb-5 lg:mb-5 max-w-[320px] sm:max-w-[520px] lg:max-w-[800px] text-center">
                            <h2 className={`${titleColor} text-xl sm:text-xl lg:text-2xl font-bold`}>
                                {title}
                            </h2>
                        </div>
                    </div>
                </div>
            )}

            <div className="-mx-4 flex flex-wrap">
                <div className="w-full px-4">
                    {questions.map((item, index) => (
                        <AccordionItem
                            key={index}
                            header={item.question}
                            text={item.answer}
                            isDark={isDark}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

const AccordionItem = ({ header, text, isDark }) => {
    const [active, setActive] = useState(false);

    const handleToggle = (e) => {
        e.preventDefault();
        setActive(!active);
    };

    const svgColor = isDark ? "fill-white stroke-white" : "fill-[#2C6E63] stroke-[#2C6E63]";
    const headerColor = isDark ? "text-white" : "text-[#2C6E63]";
    const textColor = isDark ? "text-white/90" : "";

    return (
        <div className="mb-0.5 w-full rounded-lg bg-transparent p-2 sm:p-4 lg:px-3 xl:px-2">
            <button
                className={`faq-btn flex w-full text-center md:text-left lg:text-left`}
                onClick={handleToggle}
            >
                <div className="mr-5 flex h-10 w-full max-w-[40px] items-center justify-center rounded-lg bg-white/5">
                    <svg
                        className={`${svgColor} duration-200 ease-in-out ${active ? "rotate-180" : ""}`}
                        width="17"
                        height="10"
                        viewBox="0 0 17 10"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                        />
                    </svg>
                </div>

                <div className="w-full">
                    <h3 className={`mt-1 ${headerColor} font-bold text-lg sm:text-lg md:text-xl lg:text-xl`}>
                        {header}
                    </h3>
                </div>
            </button>

            <div
                className={`pl-[62px] duration-200 ease-in-out ${active ? "block" : "hidden"}`}
            >
                <p className={`py-2 text-center md:text-left lg:text-left text-base sm:text-base md:text-lg ${textColor}`}>
                    {text}
                </p>
            </div>
        </div>
    );
};

export default Accordion;
